/* globals EasyPost */
import Backbone from 'backbone';
import { render } from 'react-dom';

import { setLocation, location } from 'utils/wrappers';
import { setStoredValue, getStoredValue } from 'utils/storage';

/** * PUBLIC MODULE * * */
const base = Backbone.Router.extend({
  routes: {},
  targetEl: '#content-area',
  loggedIn: true,

  getTargetEl() {
    return $('body').find(this.targetEl);
  },

  renderView(instance) {
    instance.render();
    const oldView = EasyPost.Globals.currentView;
    if (oldView) {
      oldView.removeSubviews();
      oldView.remove();
      oldView.unbind();
      oldView.undelegateEvents();
    }
    EasyPost.Globals.currentView = instance;
    this.getTargetEl().html(instance.el);

    // content has been added to page. Run onDomRefresh script
    instance.onDomRefreshBase();
  },

  renderReactComponent(instance) {
    render(instance, this.getTargetEl().get(0));
  },

  redirectToHome() {
    setLocation('/');
  },

  redirectToLogin() {
    const currentLocation = (location().pathname || '') + (location().hash || '');
    setStoredValue('signinLocation', currentLocation);
    setLocation('/signin');
  },

  redirectToLoggedIn() {
    setLocation('/account/shipments');
  },

  redirectUnlessLoggedIn({ callback = this.redirectToLoggedIn, redirect }) {
    if (this.userIsLoggedIn()) {
      return callback();
    }
    if (redirect) {
      Backbone.history.navigate(redirect, { trigger: true, replace: true });
      return false;
    }
    if (this.userIsLoggedInAllowUnverified()) {
      setLocation('/verification');
      return false;
    }
    return this.redirectToLogin();
  },
  redirectUnlessLoggedInAllowUnverified({ callback = this.redirectToLoggedIn, redirect }) {
    if (this.userIsLoggedInAllowUnverified()) {
      return callback();
    }
    if (redirect) {
      Backbone.history.navigate(redirect, { trigger: true, replace: true });
      return false;
    }
    return this.redirectToLogin();
  },

  redirectUnlessLoggedOut({ callback, redirect = this.redirectToLoggedIn }) {
    if (this.userIsLoggedIn()) {
      return redirect();
    }
    return callback();
  },
  redirectUnlessLoggedOutIncludeUnverified({ callback, redirect = this.redirectToLoggedIn }) {
    if (this.userIsLoggedInAllowUnverified()) {
      return redirect();
    }
    return callback();
  },

  enforceCheckoutFlow() {
    if (getStoredValue('epsubplan')) {
      return true;
    }
    this.redirectToHome();
    return false;
  },

  enforceLogin({ callback, redirect }) {
    this.waitForUserLoad(() => this.redirectUnlessLoggedIn({ callback, redirect }));
  },
  enforceLoginAllowUnverified({ callback, redirect }) {
    this.waitForUserLoad(() => this.redirectUnlessLoggedInAllowUnverified({ callback, redirect }));
  },
  enforceNotLoggedIn({ callback, redirect }) {
    this.waitForUserLoad(() => this.redirectUnlessLoggedOut({ callback, redirect }));
  },
  enforceNotLoggedInIncludeUnverified({ callback, redirect }) {
    this.waitForUserLoad(() => this.redirectUnlessLoggedOutIncludeUnverified({
      callback,
      redirect,
    }));
  },
  checkForHash(substring = 1) {
    return Backbone.history.location.hash.length > 0
        && Backbone.history.location.hash.substring(substring);
  },
  userIsLoggedIn() {
    return EasyPost.Globals.currentUser && EasyPost.Globals.currentUser.isLoggedIn();
  },
  userIsLoggedInAllowUnverified() {
    return EasyPost.Globals.currentUser && EasyPost.Globals.currentUser.isLoggedInAllowUnverified();
  },
  waitForUserLoad(callback) {
    if (EasyPost.Globals.firstFetchComplete) {
      callback();
    } else {
      this.listenToOnce(EasyPost.Globals.currentUser, 'error sync', () => {
        // Backbone listens once for EACH event
        this.stopListening(EasyPost.Globals.currentUser);
        callback();
      });
    }
  },
});

export default base;



// WEBPACK FOOTER //
// ./app/routers/base.js